import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "custom-host-boot-block flex-mid",
  style: {
    "min-height": "100vh",
    "flex-direction": "column",
    "padding": "2.4rem",
    "text-align": "center",
    "box-sizing": "border-box"
  }
};
const _hoisted_2 = {
  class: "fw-700 fs-22 fc-1B1C1E",
  style: {
    "max-width": "42rem"
  }
};
const _hoisted_3 = {
  class: "fs-14 mt-16",
  style: {
    "max-width": "42rem",
    "color": "#696c80"
  }
};
const _hoisted_4 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_lazy_navbar = _resolveComponent("lazy-navbar");
  const _component_router_view = _resolveComponent("router-view");
  const _component_toolbox_overlay = _resolveComponent("toolbox-overlay");
  const _component_lazy_help_support_fab = _resolveComponent("lazy-help-support-fab");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${_ctx.$t('lang_code') == 'th' ? '' : ''}`)
  }, [_ctx.customHostBootBlocked ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.customHostBootTitle), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.customHostBootBody), 1)])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_ctx.$route.meta.navbar ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_lazy_navbar)])) : _createCommentVNode("", true), _ctx.isToolboxRoute ? (_openBlock(), _createBlock(_component_toolbox_overlay, {
    key: 1,
    onClose: _ctx.closeToolbox
  }, {
    default: _withCtx(() => [_createVNode(_component_router_view)]),
    _: 1
  }, 8, ["onClose"])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createVNode(_component_router_view), _ctx.showFab ? (_openBlock(), _createBlock(_component_lazy_help_support_fab, {
    key: 0
  })) : _createCommentVNode("", true)], 64))], 64))], 2);
}